
import React from "react";
import { Card } from "@/components/ui/card";

const LoadingState = () => {
  return (
    <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
      {[...Array(3)].map((_, index) => (
        <Card key={index} className="animate-pulse">
          <div className="bg-slate-200 dark:bg-nalc-dark/40 h-24 rounded-t-lg"></div>
          <div className="py-6 px-6">
            <div className="h-64 bg-slate-200 dark:bg-nalc-dark/40 rounded"></div>
          </div>
        </Card>
      ))}
    </div>
  );
};

export default LoadingState;
